var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ShareService } from '../../../../services/share.service';
import { VisitorSettingsStore } from '../../../../stores/visitor.calendar.store';
import { EditPlaceModalComponent } from '../../edit.place.modal/edit.place.modal.component';
import { EditPlaceModalActions } from '../../edit.place.modal/edit.place.modal.provider';
import { getRouteUrl, routeConfigs } from '../../../../common/constants/route.config';
import { AuthService } from '../../../../common/services/auth.service';
import { ModalService } from '../../../../common/services/modal.service';
import { HubPlace } from '../../../../models/hub/hub.place';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { HubCalendarComponent } from '../hub.calendar.component';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
import { PlaceService } from '../../../../services/place.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { EditPlaceCategoryModalActions } from '../../edit.place.category.modal/edit.place.category.modal.provider';
import { EditPlaceCategoryModalComponent } from '../../edit.place.category.modal/edit.place.category.modal.component';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import { ShowPromptModalComponent } from '../../show.prompt.modal/show.prompt.modal.component';
import { PromptModalData, ShowPromptModalActions } from '../../show.prompt.modal/show.prompt.modal.provider';
import { clone } from '../../../../common/extensions';
import { KeywordService } from '../../../../services/keyword.service';
var HubPlaceCardComponent = /** @class */ (function (_super) {
    __extends(HubPlaceCardComponent, _super);
    function HubPlaceCardComponent(router, activatedRoute, modalService, authService, hubApiService, imageService, editorChoiceStore, customizationApiService, visitorSettingsCommand, alertify, parent, keywordService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.editorChoiceStore = editorChoiceStore;
        _this.customizationApiService = customizationApiService;
        _this.visitorSettingsCommand = visitorSettingsCommand;
        _this.alertify = alertify;
        _this.parent = parent;
        _this.keywordService = keywordService;
        _this.editorChoiceText = '';
        _this.addToEditorChoiceTextTip = 'Add to ';
        _this.removeFromEditorChoiceTextTip = 'Remove from ';
        _this.notAllowed = false;
        _this.searchFields = [];
        return _this;
    }
    HubPlaceCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe(function (editorChoice) {
            _this.editorChoiceText = editorChoice.editorChoiceForPlace;
            _this.addToEditorChoiceTextTip += _this.editorChoiceText;
            _this.removeFromEditorChoiceTextTip += _this.editorChoiceText;
        });
        this.visitorSettingsCommand.settingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (settings) {
            _this.customSettings = settings;
        });
        this.keywordSubscription = this.keywordService.keyword$.subscribe(function (k) { return _this.keyword = k; });
    };
    HubPlaceCardComponent.prototype.ngOnDestroy = function () {
        this.keywordSubscription.unsubscribe();
    };
    HubPlaceCardComponent.prototype.showReadable = function (code) {
        return PlaceService.allToReadableCategory(code);
    };
    HubPlaceCardComponent.prototype.showEditCategoryModal = function () {
        var _this = this;
        var actions = {
            confirm: function (event, category) {
                _this.place.category = category.category;
                _this.place.categoryList = category.categoryList;
                _this.place.categoryText = category.categoryText;
                _this.hubApiService.updatePlace(_this.place.hubName, _this.place._id, _this.place).subscribe(function () { });
            },
        };
        this.modalService.show({
            component: EditPlaceCategoryModalComponent,
            providers: [
                { provide: EditPlaceCategoryModalActions, useValue: actions },
                { provide: HubPlace, useValue: this.place },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    HubPlaceCardComponent.prototype.approve = function () {
        var _this = this;
        if (this.notAllowed) {
            this.alertify.warning("This place's category is not in the allowed list, please update it.");
            return;
        }
        this.isOperating = true;
        this.hubApiService
            .approvePlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isApproved = true;
        });
    };
    HubPlaceCardComponent.prototype.unApprove = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unApprovePlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isApproved = false;
        });
    };
    HubPlaceCardComponent.prototype.pin = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .pinPlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.parent.pinPlace(_this.place);
        });
    };
    HubPlaceCardComponent.prototype.unPin = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unPinPlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.parent.unPinPlace(_this.place);
        });
    };
    HubPlaceCardComponent.prototype.choice = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .choicePlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isChoice = true;
        });
    };
    HubPlaceCardComponent.prototype.unChoice = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unChoicePlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isChoice = false;
        });
    };
    HubPlaceCardComponent.prototype.custom = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .customPlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isCustom = true;
        });
    };
    HubPlaceCardComponent.prototype.unCustom = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unCustomPlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isCustom = false;
        });
    };
    HubPlaceCardComponent.prototype.toBeExport = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .toBeExportPlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isToBeExport = true;
        });
    };
    HubPlaceCardComponent.prototype.unToBeExport = function () {
        var _this = this;
        this.isOperating = true;
        this.hubApiService
            .unToBeExportPlace(this.hubName, this.place._id)
            .finally(function () { return (_this.isOperating = false); })
            .subscribe(function () {
            _this.place.isToBeExport = false;
        });
    };
    HubPlaceCardComponent.prototype.addOrRemoveToCustomBtn = function (btn, index) {
        var _this = this;
        if (!this.isInCustomBtn(btn)) {
            this.hubApiService.addPlaceToCustomBtn(this.hubName, this.place._id, index).subscribe(function (customPlaces) {
                _this.parent.customBtns.places = customPlaces;
            });
        }
        else {
            this.hubApiService.removePlaceFromCustomBtn(this.hubName, this.place._id, index).subscribe(function (customPlaces) {
                _this.parent.customBtns.places = customPlaces;
            });
        }
    };
    HubPlaceCardComponent.prototype.isInCustomBtn = function (btn) {
        var _this = this;
        if (btn) {
            return btn.places.any(function (x) { return x === _this.place._id; });
        }
        else {
            var isIn = false;
            if (this.parent.customBtns.places) {
                for (var _i = 0, _a = this.parent.customBtns.places; _i < _a.length; _i++) {
                    var x = _a[_i];
                    if (x.places.any(function (x) { return x === _this.place._id; })) {
                        isIn = true;
                        break;
                    }
                }
            }
            return isIn;
        }
    };
    HubPlaceCardComponent.prototype.showEditModal = function () {
        var _this = this;
        var actions = {
            confirm: function (event, place) {
                _this.place = place;
                if (_this.place.cover && _this.place.cover.source) {
                    _this.place.cover.source = _this.imageService.imageSourceUrl(_this.place.cover.source);
                }
            },
        };
        this.modalService.show({
            component: EditPlaceModalComponent,
            providers: [
                { provide: EditPlaceModalActions, useValue: actions },
                { provide: HubPlace, useValue: clone(this.place) },
            ],
            panelClass: ['width-modal-4', 'ig-edit-place-modal', 'transition-50'],
        });
    };
    HubPlaceCardComponent.prototype.block = function () {
        var _this = this;
        this.isOperating = true;
        var actions = {
            confirm: function (event) {
                _this.hubApiService
                    .blockPlace(_this.hubName, _this.place._id)
                    .finally(function () {
                    event.complete();
                    _this.isOperating = false;
                })
                    .subscribe(function () {
                    _this.parent.removePlace(_this.place);
                    var doNotShowModal = localStorage.getItem(localStorageKeys.doNotShowRemoveSuccessfullyModal);
                    if (!doNotShowModal) {
                        _this.showRmoveSuccessModal();
                    }
                });
            },
            cancel: function () {
                _this.isOperating = false;
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to remove this place?',
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    HubPlaceCardComponent.prototype.gotoWebsite = function () {
        if (this.place.hostLink) {
            window.open(this.place.hostLink, '_blank');
        }
    };
    HubPlaceCardComponent.prototype.updateImage = function () {
        this.hubApiService
            .updateFBImage(this.place.hostLink, this.place._id, this.place.name || this.place.title)
            .subscribe(function (data) {
            console.log(JSON.stringify(data));
        });
    };
    HubPlaceCardComponent.prototype.showId = function () {
        ShareService.getFacebookPlaceId(this.place.hostLink);
    };
    HubPlaceCardComponent.prototype.addOrRemoveFromTour = function (tour) {
        var _this = this;
        if (!this.isInTour(tour)) {
            this.hubApiService
                .addAttractionToTour(this.hubName, { id: tour._id, feedType: 'place', feedId: this.place._id })
                .subscribe(function () {
                var currentTour = _this.parent.tours.find(function (x) { return x._id === tour._id; });
                if (currentTour) {
                    currentTour.days[0].attractions.push({
                        feedId: _this.place._id,
                        feedType: 'place',
                    });
                }
                // this.hubApiService.getTours(this.hubName).subscribe((tours) => {
                //   this.parent.tours = tours;
                // });
            });
        }
        else {
            this.hubApiService
                .removeAttractionFromTour(this.hubName, {
                id: tour._id,
                attractionId: this.place._id,
                feedType: 'place',
            })
                .subscribe(function () {
                var currentTour = _this.parent.tours.find(function (x) { return x._id === tour._id; });
                if (currentTour) {
                    currentTour.days.forEach(function (day) {
                        day.attractions = day.attractions.filter(function (x) { return x.feedId !== _this.place._id; });
                    });
                }
                // this.hubApiService.getTours(this.hubName).subscribe((tours) => {
                //   this.parent.tours = tours;
                // });
            });
        }
    };
    HubPlaceCardComponent.prototype.gotoTours = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.tours, {
                            hubName: this.hubName,
                        }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HubPlaceCardComponent.prototype.showMarketing = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.marketing, {
            hubName: this.hubName,
        }));
    };
    HubPlaceCardComponent.prototype.isInTour = function (tour) {
        var _this = this;
        if (tour) {
            return tour.days.some(function (x) { return x.attractions.some(function (x) { return x.feedId === _this.place._id; }); });
        }
        else {
            if (!this.parent.tours) {
                return false;
            }
            return this.parent.tours.some(function (tour) {
                return tour.days.some(function (day) {
                    return day.attractions.some(function (attraction) {
                        return attraction.feedId === _this.place._id;
                    });
                });
            });
        }
    };
    HubPlaceCardComponent.prototype.showRmoveSuccessModal = function () {
        this.modalService.show({
            component: ShowPromptModalComponent,
            providers: [
                { provide: ShowPromptModalActions, useValue: null },
                {
                    provide: PromptModalData,
                    useValue: new PromptModalData('Remove successfully', null, [
                        'The selected item has been successfully removed from the dashboard.',
                        'You can restore this item from the Removed List at any time.',
                        'While in the Removed List, this item cannot be pulled again.'
                    ]),
                },
            ],
            panelClass: 'width-modal-2',
        });
    };
    Object.defineProperty(HubPlaceCardComponent.prototype, "isSearchName", {
        get: function () {
            return this.searchFields.length === 0 || this.searchFields.indexOf('name') > -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubPlaceCardComponent.prototype, "isSearchAddress", {
        get: function () {
            return this.searchFields.indexOf('address') > -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubPlaceCardComponent.prototype, "isSearchCategory", {
        get: function () {
            return this.searchFields.indexOf('category') > -1;
        },
        enumerable: true,
        configurable: true
    });
    return HubPlaceCardComponent;
}(BaseComponent));
export { HubPlaceCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/calendar/place.card/hub.place.card.component.ts.pre-build-optimizer.js